module.exports = __webpack_public_path__ + "img/red100.6371eff8.svg";